import React, { useEffect } from 'react';
import { BrowserRouter, Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { SiteLayout } from './components/SiteLayout';
import { Home } from './pages/Home';
import { About } from './pages/About';
import { Contact } from './pages/Contact';
import { ProductsOverview } from './pages/products/ProductsOverview';
import { StarterKits } from './pages/products/StarterKits';
import { ToolHolders } from './pages/products/ToolHolders';
import { Inserts } from './pages/products/Inserts';
import { Accessories } from './pages/products/Accessories';
import { ApplicationsOverview } from './pages/applications/ApplicationsOverview';
import { Aluminum } from './pages/applications/Aluminum';
import { CopperSoftAlloys } from './pages/applications/CopperSoftAlloys';
import { Titanium } from './pages/applications/Titanium';
import { TechnicalResources } from './pages/resources/TechnicalResources';
import { StartingDataPage } from './pages/resources/StartingDataPage';
import { ToolSelectionPage } from './pages/resources/ToolSelectionPage';
import { WorkholdingSafety } from './pages/resources/WorkholdingSafety';

/** Former prototype placeholder paths → their consolidated destinations.
 *  Client-side prototype redirects only, not production 301 rules. */
const placeholderRedirects: {
  from: string;
  to: string;
}[] = [{
  from: '/company-history/',
  to: '/about/'
}, {
  from: '/historic-work/',
  to: '/about/'
}, {
  from: '/where-to-buy/',
  to: '/contact/'
}, {
  from: '/careers/',
  to: '/contact/'
}, {
  from: '/privacy/',
  to: '/contact/'
}, {
  from: '/cookie-policy/',
  to: '/contact/'
}];

/**
 * Handles in-page anchors across route changes: scrolls to the hash target
 * (offset by the sticky header via CSS scroll-margin) or to the top.
 */
function RouteScroll() {
  const {
    pathname,
    hash
  } = useLocation();
  useEffect(() => {
    const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (hash) {
      const target = document.querySelector(hash);
      if (target) {
        target.scrollIntoView({
          behavior: prefersReduced ? 'auto' : 'smooth',
          block: 'start'
        });
        return;
      }
    }
    window.scrollTo({
      top: 0,
      behavior: 'auto'
    });
  }, [pathname, hash]);
  return null;
}
export function App() {
  return <BrowserRouter data-id="element-0" data-mp="864afiic4cb3">
      <RouteScroll data-id="element-1" data-mp="83i2vivg1wsv" />
      <SiteLayout data-id="element-2" data-mp="3gle90gn0mze4">
        <Routes data-id="element-3" data-mp="3gkv1zuywlvev">
          <Route path="/" element={<Home data-id="element-5" data-mp="3glnze5bz38kc" />} data-id="element-4" data-mp="3gmfu7dxqx29k" />
          <Route path="/products/" element={<ProductsOverview data-id="element-7" data-mp="3bmtgz4hx3m0r" />} data-id="element-6" data-mp="3gj1s86szuv2n" />
          <Route path="/products/starter-kits/" element={<StarterKits data-id="element-9" data-mp="3qb7lrkyw9kjy" />} data-id="element-8" data-mp="3bnutzeihuil4" />
          <Route path="/products/holders/" element={<ToolHolders data-id="element-11" data-mp="3qdaisoygsdy6" />} data-id="element-10" data-mp="3qbg07hao0xx9" />
          <Route path="/products/inserts/" element={<Inserts data-id="element-13" data-mp="3ljpi2p5hl5va" />} data-id="element-12" data-mp="3lkr5lt3ovktw" />
          <Route path="/products/accessories/" element={<Accessories data-id="element-15" data-mp="2xud99qe2mzti" />} data-id="element-14" data-mp="3lj67jti61jra" />
          <Route path="/applications/" element={<ApplicationsOverview data-id="element-17" data-mp="2xsk289zjqdkz" />} data-id="element-16" data-mp="2xtlprdxr0sjl" />
          <Route path="/applications/aluminum/" element={<Aluminum data-id="element-19" data-mp="2svjyw6u2zoxk" />} data-id="element-18" data-mp="2swll97gjrxul" />
          <Route path="/applications/copper-soft-alloys/" element={<CopperSoftAlloys data-id="element-21" data-mp="18bok0lajc9wf" />} data-id="element-20" data-mp="18drjrx1hphec" />
          <Route path="/applications/titanium/" element={<Titanium data-id="element-23" data-mp="1d5suhej0f029" />} data-id="element-22" data-mp="1d4recvn4zndo" />
          <Route path="/technical-resources/" element={<TechnicalResources data-id="element-25" data-mp="ygwl9e57vh02" />} data-id="element-24" data-mp="yflkln72ipd6" />
          <Route path="/technical-resources/starting-data/" element={<StartingDataPage data-id="element-27" data-mp="13ey4bz2n7gbj" />} data-id="element-26" data-mp="ydil8ck0zjvs" />
          <Route path="/technical-resources/tool-selection/" element={<ToolSelectionPage data-id="element-29" data-mp="1w3c34h1k2go5" />} data-id="element-28" data-mp="1r4iqequ3etp1" />
          <Route path="/technical-resources/safety/" element={<WorkholdingSafety data-id="element-31" data-mp="1i4401d29uoeo" />} data-id="element-30" data-mp="1w2as2ckjhu6f" />
          <Route path="/about/" element={<About data-id="element-33" data-mp="1i5xc57vnm0u2" />} data-id="element-32" data-mp="1i31e7jjt3c5m" />
          <Route path="/contact/" element={<Contact data-id="element-35" data-mp="1m3uwnxehbyr4" />} data-id="element-34" data-mp="1m4mulevju8kk" />
          {placeholderRedirects.map(r => <Route key={r.from} path={r.from} element={<Navigate to={r.to} replace data-id="element-37" data-mp="apr856qnv2tg" />} data-id="element-36" data-mp="6nw43uhcibbz" />)}
          <Route path="*" element={<Navigate to="/" replace data-id="element-39" data-mp="qwvos6dw892o" />} data-id="element-38" data-mp="anwl9mvtx0mq" />
        </Routes>
      </SiteLayout>
    </BrowserRouter>;
}